const t = `<svg width="9" height="16" viewBox="0 0 9 16" xmlns="http://www.w3.org/2000/svg">\r
    <path d="M1.5 0.500001L9 8L1.5 15.5L0.168749 14.1687L6.3375 8L0.16875 1.83125L1.5 0.500001Z"/>\r
</svg>`;
export {
  t as default
};
